import { type DatetimeConfig, datetime } from './datetime-config';

interface DDayParams {
  dDay: DatetimeConfig;
  targetDate?: DatetimeConfig;
}

/**
 * 특정 날짜와 D-day 사이의 일수를 반환합니다
 * @param params.dDay - D-day 날짜
 * @param params.targetDate - 기준 날짜 (기본값: 오늘)
 * @returns {number} D-day까지 남은 일수 (D-day 이전: 음수, D-day: 0, D-day 이후: 양수)
 * @example
 * ```typescript
 * // 오늘 기준 D-day까지 남은 일수
 * getDDay({ dDay: '2024-03-31' }); // 음수: D-day 전, 0: D-day, 양수: D-day 후
 *
 * // 특정 날짜 기준 D-day까지 남은 일수
 * getDDay({
 *   dDay: '2024-03-31',
 *   targetDate: '2024-03-15'
 * });
 * ```
 */
export const getDDay = ({ dDay, targetDate = datetime().format('YYYY-MM-DD') }: DDayParams): number => {
  const target = datetime(targetDate).startOf('day');
  const deadline = datetime(dDay).startOf('day');

  return target.diff(deadline, 'day');
};
